
<div class="side-nav-panel-content">

  <div *ngIf="isDialog" id="firstTimeVanDialog">
    <label>Hi {{profile.firstName}}! Welcome to CVV</label>
    <div id="vanModalDetailText">
      Before you can use the application you must setup a van profile.<br>
      (This can be changed later in the profile menu)
    </div>
  </div>

  <div class="profile_nameDisplay">{{makeAccountName(profile)}}</div>

  <form class="van-profile-form" [formGroup]="formGroup" (ngSubmit)="saveProfile()" ngNativeValidate>

  <div class="form-row">

    <div class="form-vert-grp">

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Van Selection</mat-label>
        <mat-select formControlName="vanDriverVanNumberPref">
          <mat-option *ngFor="let van of vanList" [value]="van.vanId">
            {{van.vanId}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>3-Letter Label</mat-label>
        <input matInput formControlName="vanDriverInitialsPref"
          maxlength="3"
          (keypress)="keyPressAlphaNumeric($event)"
          (keyup)="keyUpUpperCase()"
          (blur)="updateVanImage()">
      </mat-form-field>
    </div>

    <div class="van-color-edit">
      <div class="profileVanImagePreview">
        <svg id="svg3" preserveAspectRatio="xMinYMin meet" viewBox="0 0 55 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                <g id="Vehicles" sketch:type="MSLayerGroup" transform="translate(6.000000, 6.000000)">
                    <g id="Van">
                        <path d="M24.8070357,2.06482517 C24.8070357,0.927128915 23.8679812,0 22.7095988,0 L21.3355462,0 C20.1765045,0 19.2381093,0.92445372 19.2381093,2.06482517 L19.2381093,2.84035368 C9.61326938,3.44910139 4.34680048,2.87572654 2.1703667,6.04477612 L0,47.5951992 L2.17036664,47.5951992 L2.17036664,51.8642324 C2.17036664,53.0439961 3.14446402,54 4.34680037,54 L6.52399943,54 C7.72633578,54 8.70111346,53.0439961 8.70111346,51.8642324 L8.70111346,47.5951992 L35.2005519,47.5951992 L35.2005519,51.8642324 C35.2005519,53.0439961 36.1753296,54 37.3782612,54 L39.5560555,53.9999166 C40.7577116,53.9999166 41.7311287,53.0439127 41.7311287,51.864149 L41.7311287,47.5951158 L43.538879,47.5951158 L40.6658655,6.04477612 C39.556055,3.42537313 34.1847955,3.59158205 24.8070357,2.87572659 L24.8070357,2.06482517 Z" id="Shape" attr.stroke="{{color1.value.substring(0,7)}}" stroke-width="5.11627907" attr.fill="{{color1.value.substring(0,7)}}" sketch:type="MSShapeGroup"></path>
                        <path d="M24.8070357,2.06482517 C24.8070357,0.927128915 23.8679812,0 22.7095988,0 L21.3355462,0 C20.1765045,0 19.2381093,0.92445372 19.2381093,2.06482517 L19.2381093,2.84035368 C9.61326938,3.44910139 4.34680048,2.87572654 2.1703667,6.04477612 L0,47.5951992 L2.17036664,47.5951992 L2.17036664,51.8642324 C2.17036664,53.0439961 3.14446402,54 4.34680037,54 L6.52399943,54 C7.72633578,54 8.70111346,53.0439961 8.70111346,51.8642324 L8.70111346,47.5951992 L35.2005519,47.5951992 L35.2005519,51.8642324 C35.2005519,53.0439961 36.1753296,54 37.3782612,54 L39.5560555,53.9999166 C40.7577116,53.9999166 41.7311287,53.0439127 41.7311287,51.864149 L41.7311287,47.5951158 L43.538879,47.5951158 L40.6658655,6.04477612 C39.556055,3.42537313 34.1847955,3.59158205 24.8070357,2.87572659 L24.8070357,2.06482517 Z" id="Shape" attr.fill="{{color.value.substring(0,7)}}" sketch:type="MSShapeGroup"></path>
                        <path d="M35.8486939,32.0943396 C33.5709957,32.0943396 31.7209302,33.9070868 31.7209302,36.1426044 C31.7209302,38.3782275 33.5709957,40.1909746 35.8486939,40.1909746 C38.1299395,40.1909746 39.976565,38.3782275 39.976565,36.1426044 C39.976565,33.9071922 38.1299395,32.0943396 35.8486939,32.0943396 L35.8486939,32.0943396 Z" id="Path" attr.fill="{{color1.value.substring(0,7)}}" sketch:type="MSShapeGroup"></path>
                        <path d="M8.73241478,32.0943396 C6.45213659,32.0943396 4.60465116,33.9070868 4.60465116,36.1426044 C4.60465116,38.3782275 6.45224409,40.1909746 8.73241478,40.1909746 C11.0119405,40.1909746 12.8602859,38.3782275 12.8602859,36.1426044 C12.8602859,33.9071922 11.0119405,32.0943396 8.73241478,32.0943396 L8.73241478,32.0943396 Z" id="Path" attr.fill="{{color1.value.substring(0,7)}}" sketch:type="MSShapeGroup"></path>
                        <text id="{{initials.substring(0,3)}}" attr.fill="{{color1.value.substring(0,7)}}" sketch:type="MSTextLayer" font-family="Tahoma" font-size="16.0" font-weight="normal" text-align="center" sketch:alignment="middle"><tspan x="6.0" y="25.1320755">{{initials.substring(0,3)}}</tspan></text>
                    </g>
                </g>
            </g>
        </svg>
      </div>
      <div class="previewText">Preview</div><br>
    </div>

  </div>


  <div class="color-container">
    <mat-form-field floatLabel="always" class="color-select" appearance="outline" subscriptSizing="dynamic">
      <mat-select [placeholder]="placeholder" (selectionChange)="updateColor($event)" formControlName="vanBgColorPref">
        <mat-option *ngFor="let c of colors" [value]="c" [style.color]="c.foreground" [style.background-color]="c.value">
          {{ c.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="color-preview" [style.background-color]="color.value" [style.color]="color.foreground"></div>

    <div style="width:20px"></div>

    <mat-form-field floatLabel="always" class="color-select" appearance="outline" subscriptSizing="dynamic">
      <mat-select [placeholder]="placeholder1" (selectionChange)="updateColor1($event)" formControlName="vanFontColorPref">
        <mat-option *ngFor="let c of colors" [value]="c" [style.color]="c.foreground" [style.background-color]="c.value">
          {{ c.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="color-preview" [style.background-color]="color1.value" [style.color]="color1.foreground"></div>
  </div>

  <div class="form-save-row">
    <div *ngIf="!isDialog">
      <mat-slide-toggle color="primary" formControlName="onBreak" [hideIcon]="true">On-Break</mat-slide-toggle>
    </div>
    <div>
      <button *ngIf="!isDialog" mat-button color="primary" type="button" (click)="cancelProfileUpdate()">Cancel</button>
      <button mat-flat-button color="primary" type="submit">
       <span>
          Save Profile
       </span>
      </button>
    </div>
  </div>

  <div *ngIf="formErrorMsg !== ''" class="alert alert-danger formErrorMsg" role="alert">
    {{formErrorMsg}}
  </div>

  </form>
</div>
